function safeAccessShadowDOM(
  selector,
  callback,
  maxRetry = 15,
  interval = 600,
  root
) {
  let retryCount = 0;
  const timer = setInterval(() => {
    const host = root
      ? root.querySelector(selector)
      : document.querySelector(selector);
    // 宿主元素不存在
    if (!host) {
      if (retryCount++ >= maxRetry) {
        clearInterval(timer);
        console.error(`Element ${selector} not found`);
      }
      return;
    }
    // 检测Shadow Root
    if (host.shadowRoot) {
      clearInterval(timer);
      callback(host.shadowRoot);
    }
    // 宿主存在但无ShadowRoot
    else if (retryCount++ >= maxRetry) {
      clearInterval(timer);
      console.error(`ShadowRoot not attached to ${selector}`);
    }
  }, interval);
}

window.addEventListener("load", function() {
    let loginnedIn = shopifyCustomer.loggedIn;
    if(!loginnedIn){
      safeAccessShadowDOM(
      ".gw-rd-ways-to-earn-page-widget-placeholder",
      (root) => {
        // 创建style元素并注入CSS
        const style = document.createElement("style");
        style.textContent = `
        .create-account-contair{
            display:flex;
            justify-content:flex-start;
            align-items:center;
            gap:24px;
            padding:24px 80px;
            background-color:#20413B !important;
            border-radius:5px;
            cursor:pointer;
        }
        .create-account-content{
           display:flex;
           flex-direction:column;
        }
        .create-account-title{
            font-size:32px;
            font-weight:400;
            color:#fff !important;
            margin:0;
            margin-bottom:16px;
        }
        .create-account-subtitle{
            font-size:14px;
            font-weight:300;
            text-align:left;
            color:#fff !important;
            margin:0;
        }
        @media (max-width: 768px) {
            .create-account-contair{
               padding:24px 36px;
            }
            .create-account-svg svg{
                width:30px;
                height:30px;
            }
            .create-account-title{
                font-size:24px;
            }
            .create-account-subtitle{
                font-size:13px;
            }
        }
    `;
        // 插入到shadow DOM中
        root.appendChild(style);
        let rootDom = root.querySelector(".gw-rd-page-widget-title");
        let innerContent = `
        <div class="create-account-contair" onclick="window.location.href='https://sylvoxtv.com/account/register?return_url=%2Fpages%2Frewards'">
            <div class="create-account-svg">
                <svg t="1749800268934" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4269" width="40" height="40"><path d="M914.285714 1024v-236.982857a159.451429 159.451429 0 0 0-160.914285-157.257143H270.628571A159.451429 159.451429 0 0 0 109.714286 787.017143V1024" p-id="4270" fill="#ffffff"></path><path d="M243.565714 262.582857a268.434286 262.582857 0 1 0 536.868572 0 268.434286 262.582857 0 1 0-536.868572 0Z" p-id="4271" fill="#ffffff"></path></svg>
            </div>
            <div class="create-account-content">
                <p class="create-account-title">Create account</p>
                <p class="create-account-subtitle">5% Off discount</p>
            </div>
        </div>
       
    `;
          $(rootDom).after(innerContent);
      },
      15,
      700
    ); // 最多重试20次，每次间隔100ms
    }
    // Ways to earn points click
    safeAccessShadowDOM(
      ".gw-rd-ways-to-earn-page-widget-placeholder",
      (root) => {
        let rootClickCardTotal = root.querySelector(".gw-rd-ways-to-earn-page-widget__list");
        let rootClickCarditem = root.querySelector(".gw-rd-page-widget-card");
        $(rootClickCardTotal).on('click',rootClickCarditem,function(event){
           event.stopPropagation(); // 阻止事件冒泡
            changeEarnModal()
      })
      },
      15,
      700
    ); // 最多重试20次，每次间隔100ms
    // Ways to spend points click
    safeAccessShadowDOM(
      ".gw-rd-ways-to-spend-page-widget-placeholder",
      (root) => {
        let rootClickCardTotal = root.querySelector(".gw-rd-ways-to-spend-page-widget__list");
        let rootClickCarditem = root.querySelector(".gw-rd-page-widget-card");
        $(rootClickCardTotal).on('click',rootClickCarditem,function(event){
           event.stopPropagation(); // 阻止事件冒泡
            changeSpendModal()
      })
      },
      15,
      700
    ); // 最多重试20次，每次间隔100ms
    // Available rewards click
    safeAccessShadowDOM(
      ".gw-rd-available-rewards-page-widget-placeholder",
      (root) => {
        let rootClickCardTotal = root.querySelector(".gw-rd-available-rewards-page-widget__active-rewards");
        let rootClickCarditem = root.querySelector(".gw-rd-page-widget-card");
        $(rootClickCardTotal).on('click',rootClickCarditem,function(event){
           event.stopPropagation(); // 阻止事件冒泡
            changeAvailableModal()
      })
      },
      15,
      700
    ); // 最多重试20次，每次间隔100ms
    safeAccessShadowDOM(
      ".gw-rd-vip-tiers-page-widget-placeholder",
      (root) => {
        safeAccessShadowDOM(
          ".gw-rd-vip-tiers-single-progress-widget-container",
          (shadowRoot) => {
            // 创建style元素并注入CSS
            const style = document.createElement("style");
            style.textContent = `
            .gw-rd-vip-tiers-single-progress-widget__tier-titles>span{
                color:#fff !important;
                font-size:18px !important;
                font-weight:600 !important;
            }
            .gw-progress-bar{
            margin-top:12px !important;
            margin-bottom:12px !important;
            }
            .gw-progress-bar__inner{
                height:12px !important;
            }
            .gw-rd-vip-tiers-single-progress-widget>span{
                color:#fff !important;
                font-size:16px !important;
            }
            .gw-rd-vip-tiers-single-progress-widget>span>strong{
                font-size:22px !important;
            }
            `;

            // 插入到shadow DOM中
            shadowRoot.appendChild(style);
          },
          10,
          500,
          root
        );
      },
      15,
      700
    ); // 最多重试20次，每次间隔100ms
  });
  // 创建style元素并注入CSS
    const style = document.createElement("style");
    style.textContent = `
        .gw-modal-body{
            padding: 0 !important;
        }
        .gw-rd-page-widget-modal-body__action{
            margin-top: 0 !important;
        }
        .gw-rd-page-widget-modal-body__title{
            font-size: 42px !important;
            color: #373f47 !important;
            font-family: Kanit-Klaviyo-Hosted, Arial, 'Helvetica Neue', Helvetica, sans-serif !important;
            font-weight: bold !important;
        }
        .gw-rd-page-widget-modal-body__reward{
            margin-bottom:16px !important;
        }
        .gw-rd-page-widget-modal-body__reward,.gw-rd-page-widget-modal-body__reward span{
            color: #373f47 !important;
            font-size: 18px !important;
            font-family: Kanit-Klaviyo-Hosted, Arial, 'Helvetica Neue', Helvetica, sans-serif !important;
            font-weight: 400 !important;
        }
        .gw-rd-page-widget-modal-body__description{
            margin-top:4px !important;
        }
        .gw-rd-page-widget-modal-body__description span,.gw-rd-page-widget-modal-body__description p{
            color: #606a72;
            font-size: 14px;
            font-family: Kanit-Klaviyo-Hosted, Arial, 'Helvetica Neue', Helvetica, sans-serif;
            font-weight: 400;
        }
        .gw-rd-page-widget-modal-body__extra-info{
            border-radius: 4px !important;
            border: 1px solid rgb(96, 106, 114) !important;
            background-color: rgb(255, 255, 255) !important;
            padding-left:26px !important;
            padding-right:26px !important;
            
        }
        .gw-rd-page-widget-modal-body__extra-info div{
            margin-bottom:6px !important;
        }
        .gw-rd-page-widget-modal-body__extra-info div>span{
            font-size: 16px !important;
            font-weight: 400 !important;
            font-family: Kanit-Klaviyo-Hosted, Arial, "Helvetica Neue", Helvetica, sans-serif !important;
        }
        .gw-rd-page-widget-modal-body__action .gw-btn span,.gw-rd-page-widget-modal-body__action .gw-btn p,.gw-rd-page-widget-modal-body__title{
            font-weight: 400 !important;
        }
        .gw-rd-page-widget-modal-body__action .gw-btn{
            background: rgb(41, 127, 103) !important;
            border-radius: 6px !important;
            border:none !important;
            height: 48px !important;
            padding-left:26px !important;
            padding-right:26px !important;
        }
        .gw-rd-page-widget-modal-body__action .gw-btn span,.gw-rd-page-widget-modal-body__action .gw-btn p{
            color: rgb(255, 255, 255) !important;
            font-family: Kanit-Klaviyo-Hosted, Arial, "Helvetica Neue", Helvetica, sans-serif !important;
            font-size: 20px !important;
            font-weight: 700 !important;
        }
        .gw-modal-header__close_btn:hover{
            background-color: #FFF !important;
        }
        .gw-rd-page-widget-modal-dialog{
            max-width:530px !important;
        }
        @media (max-width: 768px) {
            .gw-modal__scrollable{
                align-items:center !important;
            }
            .gw-rd-page-widget-modal-dialog{
                width:85% !important;
                border-radius:5px !important;
            }
            .gw-rd-page-widget-modal-body__title{
                font-size:30px !important;
            }
            .gw-rd-page-widget-modal-body__reward,.gw-rd-page-widget-modal-body__reward span{
                font-size: 17px !important;
            }
            .gw-rd-page-widget-modal-body__description span,.gw-rd-page-widget-modal-body__description p{
                font-size: 13px !important;
            }
            .gw-rd-page-widget-modal-body__extra-info div>span{
                font-size: 15px !important;
            }
            .gw-rd-page-widget-modal-body__action .gw-btn{
                height: 45px !important;
            }
            .gw-rd-page-widget-modal-body__action .gw-btn p,.gw-rd-page-widget-modal-body__action .gw-btn span{
                font-size:16px !important;
            }
            .gw-modal-header__close_btn svg{
                width:16px !important;
                height:16px !important;
            }
        }
    `;
  function changeEarnModal() {
    safeAccessShadowDOM(
          ".gw-rd-ways-to-earn-page-widget-modal-placeholder",
          (shadowRoot) => {
            // 插入到shadow DOM中
            shadowRoot.appendChild(style);
          },
          15,
          300
        ); // 最多重试20次，每次间隔100ms
  }
  function changeSpendModal() {
    safeAccessShadowDOM(
          ".gw-rd-ways-to-spend-page-widget-modal-placeholder",
          (shadowRoot) => {
            // 插入到shadow DOM中
            shadowRoot.appendChild(style);
          },
          15,
          300
        ); // 最多重试20次，每次间隔100ms
  }
  function changeAvailableModal() {
    safeAccessShadowDOM(
          ".gw-rd-available-rewards-page-widget-modal-placeholder",
          (shadowRoot) => {
            // 插入到shadow DOM中
            shadowRoot.appendChild(style);
          },
          15,
          300
        ); // 最多重试20次，每次间隔100ms
  }
